import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  useMediaQuery,
  useTheme
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { LoadingButton } from '@mui/lab';
import { makeStyles } from '@mui/styles';
import palette from '../../../theme/palette';
import Iconify from '../../../fl-components/Iconify';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      alignItems: 'flex-end' // push the dialog to bottom
    }
  },
  paper: {
    // make the content full width
    [theme.breakpoints.down('md')]: {
      margin: 0,
      maxWidth: '100% !important',
      width: '100% !important',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  },
  buttonRoot: {
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between'
    }
  },
  actionButton: {
    [theme.breakpoints.down('md')]: {
      marginLeft: '0 !important'
    }
  }
}));

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function Modal({
  open,
  title,
  className,
  cancelText,
  onCancel,
  actionText,
  onAction,
  isActionDanger,
  isActionDisabled,
  isCancelDisabled,
  children,
  onClose,
  hideCloseBtn,
  maxWidth = 'sm',
  // bodyScroll,
  isBtnLoading,
  ...props
}) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const dialogProps = {
    open,
    onClose,
    // scroll: bodyScroll ? 'paper' : 'body',
    maxWidth,
    className,
    fullWidth: true
  };

  // If mobile view then add transition effect.
  if (isMobile) {
    dialogProps.TransitionComponent = Transition;
  }

  return (
    <Dialog {...dialogProps} classes={{ container: classes.root, paper: classes.paper }} {...props}>
      <DialogTitle pt={title ? '16px !important' : '32px !important'}>
        {title && title}
        {!hideCloseBtn && (
          <IconButton
            sx={{
              position: 'absolute',
              right: 8,
              top: 8
            }}
            onClick={() => onClose()}
          >
            <Iconify icon="ep:close-bold" color={palette.grey[600]} height={20} width={20} />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent sx={{ pt: '8px !important' }}>{children}</DialogContent>
      {(cancelText || actionText) && (
        <DialogActions
          classes={{ root: classes.buttonRoot }}
          sx={{
            button: {
              width: {
                xs: '100%',
                md: 'auto'
              }
            }
          }}
        >
          {cancelText && (
            <Button
              onClick={onCancel}
              variant={isMobile ? 'outlined' : 'text'}
              color="primary"
              disabled={isCancelDisabled || isBtnLoading}
            >
              {cancelText}
            </Button>
          )}
          {actionText && (
            <LoadingButton
              // classes={{ root: classes.actionButton }}
              variant="contained"
              loading={isBtnLoading}
              onClick={isActionDisabled ? () => {} : () => onAction()}
              disabled={isActionDisabled}
              color={isActionDanger ? 'error' : 'primary'}
            >
              {actionText}
            </LoadingButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func,
  actionText: PropTypes.string,
  onAction: PropTypes.func,
  isActionDanger: PropTypes.bool,
  isActionDisabled: PropTypes.bool,
  isCancelDisabled: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func,
  maxWidth: PropTypes.string,
  // bodyScroll: PropTypes.bool,
  isBtnLoading: PropTypes.bool,
  hideCloseBtn: PropTypes.bool
};
